import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/RegisterSeminarManagerment';

const getListEventOfRegistSeminarReducer = handleActions({
    [Actions.GetListRegistSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetListRegistSeminarRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetListRegistSeminarRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearListLRegistSeminar]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const getDetailOrderSeminarReducer = handleActions({
    [Actions.getDetailOrderSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getDetailOrderSeminarRequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.getDetailOrderSeminarRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.clearDetailOrderSeminarData]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateStatusRegistSeminarReducer = handleActions({
    [Actions.UpdateStatusRegistSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
        isSuccess: false,
    }),
    [Actions.UpdateStatusRegistSeminarRequestedReceived]: (state) => ({
        ...state,
        isFetching: false,
        isSuccess: true,
    }),
    [Actions.UpdateStatusRegistSeminarRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isSuccess: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearUpdateStatusRegistSeminarRequested]: () => ({
        isFetching: false,
        isSuccess: false,
        errors: {},
    }),
}, {
    isFetching: false,
    isSuccess: false,
    errors: {},
});

const resentMailOrderReducer = handleActions({
    [Actions.resentMailSeminarRequested]: (state) => ({
        ...state,
        isFetching: true,
        isSuccess: false,
    }),
    [Actions.resentMailSeminarRequestedReceived]: (state) => ({
        ...state,
        isFetching: false,
        isSuccess: true,
    }),
    [Actions.resentMailSeminarRequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        isSuccess: false,
        errors: action.payload.errors,
    }),
    [Actions.clearMailSeminar]: () => ({
        isFetching: false,
        isSuccess: false,
        errors: {},
    }),
}, {
    isFetching: false,
    isSuccess: false,
    errors: {},
});

export default combineReducers({
    get: getListEventOfRegistSeminarReducer,
    getDetail: getDetailOrderSeminarReducer,
    update: updateStatusRegistSeminarReducer,
    resentMail: resentMailOrderReducer,
});
